import { cva, type VariantProps } from 'class-variance-authority';
import { useMemo } from 'react';
import { useVariants } from '../../../hooks/tailwindThemeProvider';

import { cn } from '../utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  const { variants } = useVariants();

  const BadgeVariants = useMemo(() => {
    return cva(variants.badge.defaultStyles, {
      variants: variants.badge.variantStyles,
      defaultVariants: variants.badge.defaultVariants as any,
    });
  }, [variants]);

  return <div className={cn(BadgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
